import { Typography as MuiTypography, TypographyProps as MuiTypographyProps } from "@mui/material";
import "@mui/material/styles";
import { forwardRef } from "react";

declare module "@mui/material/styles" {
  interface TypographyVariants {
    body3: React.CSSProperties;
  }

  interface TypographyVariantsOptions {
    body3?: React.CSSProperties;
  }
}

// Update the Typography's variant prop options
declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    body3: true;
  }
}

export type TypographyProps = MuiTypographyProps & {
  overflowEllipsis?: boolean;
};

const ellipsisSx = {
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis"
};

const TypographyComponent = forwardRef<HTMLSpanElement, TypographyProps>((props, ref) => {
  const { overflowEllipsis, sx, ...rest } = props;
  const sxx = { ...sx, ...(overflowEllipsis && ellipsisSx) };

  return (
    <MuiTypography color="textPrimary" {...rest} sx={sxx} ref={ref}>
      {props.children}
    </MuiTypography>
  );
});

TypographyComponent.displayName = "Typography";

export default TypographyComponent;
